module.exports = __webpack_public_path__ + "img/logo-recycoin.7480da10.png";